import { z } from 'zod';

export const CoreDocumentScalarFieldEnumSchema = z.enum(['id','cityId','s3Url','s3Bucket','s3Key','resourceType','resourceId','deactivatedAt','createdAt','updatedAt','issuedAt']);

export default CoreDocumentScalarFieldEnumSchema;
